module.exports = __webpack_public_path__ + "static/gisela-Fun-239804564aca7932ce91f5aa54f4e3aa.jpg";